import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';

@Component({
  selector: 'cv-point-store-assign-group-attr',
  templateUrl: './point-store-assign-group-attr.component.html',
  styleUrls: ['./point-store-assign-group-attr.component.scss']
})
export class PointStoreAssignGroupAttrComponent implements OnInit {

  @Input() showall: boolean;
  @Input() attributes: any[] = [];
  @Input() lst: any[];
  @Output() onremove: EventEmitter<any> = new EventEmitter<any>();

  @Output() lstChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() showallChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() empgrouptypes: any;
  @Output() empgrouptypesChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() recgrouptypes: any;
  @Output() recgrouptypesChange: EventEmitter<any> = new EventEmitter<any>();
  @Input() datatransfer: any;
  @Output() datatransferChange: EventEmitter<any> = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  onRemove(item: any) {
    let index = this.lst.indexOf(item);
    if (index >= 0) {
      this.lst.splice(index, 1);
      this.onremove?.emit(item);
    }
  }

  /*   empSelected = function () {
      for (var i = 0; i < this.lst.length; i++) {
        if (this.lst[i].BaseGroupType == 0) return true;
      }
      return false;
    }
    recSelected = function () {
      for (var i = 0; i < this.lst.length; i++) {
        if (this.lst[i].BaseGroupType == 1) return true;
      }
      return false;
    } */

  trackByFunction(index: number, el: any) {
    return index;
  }
}
